import { render, staticRenderFns } from "./PrizeCard.vue?vue&type=template&id=c55d4914"
import script from "./prize-card.ts?vue&type=script&lang=ts&external"
export * from "./prize-card.ts?vue&type=script&lang=ts&external"
import style0 from "./prize-card.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports